import macro1 from '../images/macros/IMG_4427.jpg'
import macro2 from '../images/macros/EV2A7051.jpg'
import macro3 from '../images/macros/DC_QE1A9712.jpg'
import macro4 from '../images/macros/EV2A5938.jpg'
import macro5 from '../images/macros/IMG_5583.jpg'
import macro6 from '../images/macros/EV2A5512.jpg'
import macro7 from '../images/macros/EV2A9917.jpg'
import macro8 from '../images/macros/EV2A7523.jpg'

export const macroData = [
  {
    id: 1,
    image: macro1,
    alignment: 'horizontal',
    alt: 'macro image 1 Jari Sokka'
  },
  {
    id: 2,
    image: macro2,
    alignment: 'horizontal',
    alt: 'macro image 2 Jari Sokka'
  },
  {
    id: 3,
    image: macro3,
    alignment: 'horizontal',
    alt: 'macro image 3 Jari Sokka'
  },
  {
    id: 4,
    image: macro4,
    alignment: 'horizontal',
    alt: 'macro image 4 Jari Sokka'
  }
  ,
  {
    id: 5,
    image: macro5,
    alignment: 'horizontal',
    alt: 'macro image 5 Jari Sokka'
  }
  ,
  {
    id: 6,
    image: macro6,
    alignment: 'horizontal',
    alt: 'macro image 6 Jari Sokka'
  },
  {
    id: 7,
    image: macro7,
    alignment: 'horizontal',
    alt: 'macro image 7 Jari Sokka'
  },
  {
    id: 8,
    image: macro8,
    alignment: 'horizontal',
    alt: 'macro image 8 Jari Sokka'
  }
]